var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "constructor",
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _c("m-items", {
        attrs: {
          active: _vm.isShowModalCreateGroup,
          "modal-title": _vm.createGroupModalTitle,
          "input-placeholder": "Введите название группы",
          "required-message": _vm.requiredMessage,
          "current-group-item": _vm.currentGroup,
          "input-max-length": 64,
        },
        on: {
          changeRequiredMessage: _vm.changeRequiredMessage,
          close: _vm.closeModalCreateGroup,
          createItem: _vm.createGroupRequest,
          editItem: _vm.renameGroupRequest,
        },
      }),
      _c("m-items", {
        attrs: {
          "create-category": true,
          active: _vm.isShowModalCreateCategory,
          groups: _vm.groupsForCreateCategoryModal,
          "current-group-select": _vm.currentSelectChosenGroupCode,
          "required-message": _vm.requiredMessage,
          "current-category-item": _vm.currentCategory,
          "modal-title": _vm.createCategoryModalTitle,
          "input-max-length": 255,
          "input-placeholder": "Введите название категории",
        },
        on: {
          changeRequiredMessage: _vm.changeRequiredMessage,
          close: _vm.closeModalCreateCategory,
          createItem: _vm.createCategoryRequest,
          editItem: _vm.editCategoryRequest,
        },
      }),
      _c("m-items", {
        attrs: {
          "modal-confirm": true,
          active: _vm.isShowModalRemove,
          "modal-title": _vm.removeModalTitle,
          "modal-description": _vm.removeModalDescription,
          "modal-description-item": _vm.removeModalDescriptionItem,
          "remove-item": _vm.removeModalItem,
          "remove-item-type": _vm.removeModalItemType,
        },
        on: {
          removeItemRequest: _vm.removeItemRequest,
          close: _vm.closeModalRemove,
        },
      }),
      _c(
        "c-sidesheet",
        { attrs: { active: _vm.localActive }, on: { close: _vm.close } },
        [
          _c(
            "div",
            { staticClass: "constructor__header" },
            [
              _c(
                "svg",
                {
                  staticClass: "constructor__header__close",
                  attrs: {
                    width: "15",
                    height: "16",
                    viewBox: "0 0 15 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                  on: { click: _vm.close },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                      fill: "#8E9CBB",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                      fill: "#8E9CBB",
                    },
                  }),
                ]
              ),
              _c("div", { staticClass: "constructor__header__title" }, [
                _vm._v("Настройка групп и категорий"),
              ]),
              _c("c-button-dropdown", {
                staticClass: "constructor__header__button",
                attrs: {
                  icon: "arrow",
                  "dropdown-with-icon": true,
                  "dropdown-icon": "plus",
                  "dropdown-icon-color": "blue",
                  type: "dropdown",
                  label: "Добавить",
                  dropdown: {
                    position: "left",
                    items: [
                      { label: "Группу", emit: "createGroup" },
                      { label: "Категорию", emit: "createCategory" },
                    ],
                  },
                },
                on: {
                  createGroup: _vm.openModalCreateGroup,
                  createCategory: _vm.openModalCreateCategory,
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "constructor__wrapper" }, [
            _c("div", { staticClass: "constructor__content" }, [
              _c(
                "div",
                { staticClass: "constructor__search" },
                [
                  _c("c-input-old", {
                    attrs: {
                      icon: "search",
                      "placeholder-style": "italic",
                      placeholder: "Поиск",
                      clearable: true,
                    },
                    model: {
                      value: _vm.searchInput,
                      callback: function ($$v) {
                        _vm.searchInput = $$v
                      },
                      expression: "searchInput",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "constructor__sections" }, [
                _c("div", { staticClass: "constructor__section" }, [
                  _c(
                    "div",
                    { staticClass: "constructor__section-content" },
                    [
                      _c(
                        "draggable",
                        {
                          attrs: {
                            list: _vm.localItems,
                            group: "groups",
                            "force-fallback": true,
                            "ghost-class": "sortable__ghost",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.moveGroupRequest(
                                $event,
                                _vm.localItems
                              )
                            },
                          },
                        },
                        _vm._l(_vm.localItems, function (group, index) {
                          return _c(
                            "div",
                            { key: group.code },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle",
                                      value: `group-collapse-${group.groupId}`,
                                      expression:
                                        "`group-collapse-${group.groupId}`",
                                    },
                                  ],
                                  staticClass:
                                    "constructor__element constructor__element__bold",
                                  class: {
                                    constructor__element__last:
                                      index + 1 === _vm.localItems.length,
                                  },
                                  attrs: {
                                    id: `group-collapse-button-${group.groupId}`,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "constructor__element__ellipsis",
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "8",
                                            height: "5",
                                            viewBox: "0 0 8 5",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M3.53976 4.4727C3.28126 4.21408 3.28126 3.79476 3.53976 3.53614L6.87001 0.204315C7.12851 -0.0543084 7.54762 -0.054308 7.80612 0.204315C8.06462 0.462938 8.06462 0.88225 7.80612 1.14087L4.47587 4.4727C4.21737 4.73132 3.79826 4.73132 3.53976 4.4727Z",
                                              fill: "#0066FF",
                                            },
                                          }),
                                          _c("path", {
                                            attrs: {
                                              d: "M4.47058 4.4727C4.72908 4.21408 4.72908 3.79476 4.47058 3.53614L1.12999 0.193967C0.871489 -0.064656 0.452377 -0.0646556 0.193876 0.193968C-0.0646252 0.452591 -0.0646252 0.871902 0.193876 1.13053L3.53447 4.4727C3.79297 4.73132 4.21208 4.73132 4.47058 4.4727Z",
                                              fill: "#0066FF",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "constructor__element__name",
                                    },
                                    [_vm._v(_vm._s(group.name))]
                                  ),
                                  _c(
                                    "b-link",
                                    {
                                      staticClass: "constructor__element-icons",
                                      attrs: { disabled: "" },
                                    },
                                    [
                                      group.editable === 1
                                        ? _c("c-button", {
                                            directives: [
                                              {
                                                name: "b-popover",
                                                rawName: "v-b-popover.html",
                                                value: {
                                                  id: "positions-button-popover",
                                                  container: "#app",
                                                  trigger: "hover",
                                                  content: "Редактировать",
                                                  placement: "top",
                                                },
                                                expression:
                                                  "{\n                          id: 'positions-button-popover',\n                          container: '#app',\n                          trigger: 'hover',\n                          content: 'Редактировать',\n                          placement: 'top',\n                        }",
                                                modifiers: { html: true },
                                              },
                                            ],
                                            staticClass:
                                              "constructor__element-icons-edit",
                                            attrs: {
                                              size: "iconic",
                                              icon: "edit",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.renameGroup(group)
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.hasCategoryWithPosts(group)
                                        ? _c("c-button", {
                                            directives: [
                                              {
                                                name: "b-popover",
                                                rawName: "v-b-popover.html",
                                                value: {
                                                  id: "positions-disable-delete-popover",
                                                  container: "#app",
                                                  trigger: "click blur",
                                                  content:
                                                    _vm.getGroupTemplatePopover,
                                                },
                                                expression:
                                                  "{\n                          id: 'positions-disable-delete-popover',\n                          container: '#app',\n                          trigger: 'click blur',\n                          content: getGroupTemplatePopover,\n                        }",
                                                modifiers: { html: true },
                                              },
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.html",
                                                value: {
                                                  id: "positions-button-tooltip",
                                                  container: "#app",
                                                  trigger: "hover",
                                                  content: "Удалить",
                                                  title: "Удалить",
                                                  placement: "top",
                                                },
                                                expression:
                                                  "{\n                          id: 'positions-button-tooltip',\n                          container: '#app',\n                          trigger: 'hover',\n                          content: 'Удалить',\n                          title: 'Удалить',\n                          placement: 'top',\n                        }",
                                                modifiers: { html: true },
                                              },
                                            ],
                                            staticClass:
                                              "constructor__element-icons-delete",
                                            class: {
                                              "constructor__element-icons-delete-disabled":
                                                group.categories.length > 1 ||
                                                (group.categories[0] !==
                                                  undefined &&
                                                  group.categories[0].posts
                                                    .length > 0),
                                            },
                                            attrs: {
                                              container:
                                                "disablePopoverPositions",
                                              size: "iconic",
                                              icon: {
                                                icon: "trash",
                                                color: "secondary",
                                              },
                                              "tooltip-with-icon": "notice",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.shouldDisplayDeleteButton(group)
                                        ? _c("c-button", {
                                            directives: [
                                              {
                                                name: "b-popover",
                                                rawName: "v-b-popover.html",
                                                value: {
                                                  id: "positions-button-popover",
                                                  container: "#app",
                                                  trigger: "hover",
                                                  content: "Удалить",
                                                  placement: "top",
                                                },
                                                expression:
                                                  "{\n                          id: 'positions-button-popover',\n                          container: '#app',\n                          trigger: 'hover',\n                          content: 'Удалить',\n                          placement: 'top',\n                        }",
                                                modifiers: { html: true },
                                              },
                                            ],
                                            staticClass:
                                              "constructor__element-icons-delete",
                                            attrs: {
                                              size: "iconic",
                                              icon: {
                                                icon: "trash",
                                                color: "secondary",
                                              },
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.openModalRemove(
                                                  group,
                                                  "group"
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _c("c-button", {
                                        directives: [
                                          {
                                            name: "b-popover",
                                            rawName: "v-b-popover.html",
                                            value: {
                                              id: "positions-button-popover",
                                              container: "#app",
                                              trigger: "hover",
                                              content: "Переместить",
                                              placement: "top",
                                            },
                                            expression:
                                              "{\n                          id: 'positions-button-popover',\n                          container: '#app',\n                          trigger: 'hover',\n                          content: 'Переместить',\n                          placement: 'top',\n                        }",
                                            modifiers: { html: true },
                                          },
                                        ],
                                        attrs: {
                                          size: "iconic",
                                          icon: "arrows-constructor",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-collapse",
                                {
                                  staticClass: "constructor__groups__collapse",
                                  attrs: {
                                    id: `group-collapse-${group.groupId}`,
                                  },
                                },
                                [
                                  _c(
                                    "draggable",
                                    {
                                      class: `${group.code}`,
                                      attrs: {
                                        list: group.categories,
                                        group: "categories",
                                        move: _vm.checkCategoryMove,
                                        "force-fallback": true,
                                        "ghost-class": "sortable__ghost",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.moveCategoryRequest(
                                            $event,
                                            group
                                          )
                                        },
                                      },
                                    },
                                    _vm._l(
                                      group.categories,
                                      function (category, i) {
                                        return _c(
                                          "div",
                                          { key: `${index}-${i}` },
                                          [
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-toggle",
                                                    rawName: "v-b-toggle",
                                                    value: `group-category-collapse-${group.groupId}-${category.categoryId}`,
                                                    expression:
                                                      "`group-category-collapse-${group.groupId}-${category.categoryId}`",
                                                  },
                                                ],
                                                staticClass:
                                                  "constructor__element constructor__element__bg_grey",
                                                class: {
                                                  constructor__element__last:
                                                    i + 1 ===
                                                      group.categories.length &&
                                                    index + 1 ===
                                                      _vm.localItems.length,
                                                  constructor__element__first:
                                                    i === 0,
                                                },
                                                attrs: {
                                                  id: `group-category-collapse-button-${group.groupId}-${category.categoryId}`,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "constructor__element__ellipsis",
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        attrs: {
                                                          width: "8",
                                                          height: "5",
                                                          viewBox: "0 0 8 5",
                                                          fill: "none",
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg",
                                                        },
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M3.53976 4.4727C3.28126 4.21408 3.28126 3.79476 3.53976 3.53614L6.87001 0.204315C7.12851 -0.0543084 7.54762 -0.054308 7.80612 0.204315C8.06462 0.462938 8.06462 0.88225 7.80612 1.14087L4.47587 4.4727C4.21737 4.73132 3.79826 4.73132 3.53976 4.4727Z",
                                                            fill: "#0066FF",
                                                          },
                                                        }),
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M4.47058 4.4727C4.72908 4.21408 4.72908 3.79476 4.47058 3.53614L1.12999 0.193967C0.871489 -0.064656 0.452377 -0.0646556 0.193876 0.193968C-0.0646252 0.452591 -0.0646252 0.871902 0.193876 1.13053L3.53447 4.4727C3.79297 4.73132 4.21208 4.73132 4.47058 4.4727Z",
                                                            fill: "#0066FF",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "constructor__element__name",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(category.name)
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "b-link",
                                                  {
                                                    staticClass:
                                                      "constructor__element-icons",
                                                    attrs: { disabled: "" },
                                                  },
                                                  [
                                                    category.id !== 0
                                                      ? _c("c-button", {
                                                          directives: [
                                                            {
                                                              name: "b-popover",
                                                              rawName:
                                                                "v-b-popover.html",
                                                              value: {
                                                                id: "positions-button-popover",
                                                                container:
                                                                  "#app",
                                                                trigger:
                                                                  "hover",
                                                                content:
                                                                  "Редактировать",
                                                                placement:
                                                                  "top",
                                                              },
                                                              expression:
                                                                "{\n                                id: 'positions-button-popover',\n                                container: '#app',\n                                trigger: 'hover',\n                                content: 'Редактировать',\n                                placement: 'top',\n                              }",
                                                              modifiers: {
                                                                html: true,
                                                              },
                                                            },
                                                          ],
                                                          staticClass:
                                                            "constructor__element-icons-edit",
                                                          attrs: {
                                                            size: "iconic",
                                                            icon: "edit",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.editCategory(
                                                                category,
                                                                group.code
                                                              )
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    category.posts.length > 0 &&
                                                    category.id !== 0
                                                      ? _c("c-button", {
                                                          directives: [
                                                            {
                                                              name: "b-popover",
                                                              rawName:
                                                                "v-b-popover.html",
                                                              value: {
                                                                id: "positions-disable-delete-popover",
                                                                container:
                                                                  "#app",
                                                                trigger:
                                                                  "click blur",
                                                                content:
                                                                  _vm.getCategoryTemplatePopover,
                                                              },
                                                              expression:
                                                                "{\n                                id: 'positions-disable-delete-popover',\n                                container: '#app',\n                                trigger: 'click blur',\n                                content: getCategoryTemplatePopover,\n                              }",
                                                              modifiers: {
                                                                html: true,
                                                              },
                                                            },
                                                            {
                                                              name: "b-tooltip",
                                                              rawName:
                                                                "v-b-tooltip.html",
                                                              value: {
                                                                id: "positions-button-tooltip",
                                                                container:
                                                                  "#app",
                                                                trigger:
                                                                  "hover",
                                                                content:
                                                                  "Удалить",
                                                                title:
                                                                  "Удалить",
                                                                placement:
                                                                  "top",
                                                              },
                                                              expression:
                                                                "{\n                                id: 'positions-button-tooltip',\n                                container: '#app',\n                                trigger: 'hover',\n                                content: 'Удалить',\n                                title: 'Удалить',\n                                placement: 'top',\n                              }",
                                                              modifiers: {
                                                                html: true,
                                                              },
                                                            },
                                                          ],
                                                          staticClass:
                                                            "constructor__element-icons-delete",
                                                          class: {
                                                            "constructor__element-icons-delete-disabled":
                                                              category.posts !==
                                                                undefined &&
                                                              category.posts
                                                                .length > 0,
                                                          },
                                                          attrs: {
                                                            size: "iconic",
                                                            icon: {
                                                              icon: "trash",
                                                              color:
                                                                "secondary",
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    category.posts.length ===
                                                      0 && category.id !== 0
                                                      ? _c("c-button", {
                                                          directives: [
                                                            {
                                                              name: "b-popover",
                                                              rawName:
                                                                "v-b-popover.html",
                                                              value: {
                                                                id: "positions-button-popover",
                                                                container:
                                                                  "#app",
                                                                trigger:
                                                                  "hover",
                                                                content:
                                                                  "Удалить",
                                                                placement:
                                                                  "top",
                                                              },
                                                              expression:
                                                                "{\n                                id: 'positions-button-popover',\n                                container: '#app',\n                                trigger: 'hover',\n                                content: 'Удалить',\n                                placement: 'top',\n                              }",
                                                              modifiers: {
                                                                html: true,
                                                              },
                                                            },
                                                          ],
                                                          staticClass:
                                                            "constructor__element-icons-delete",
                                                          attrs: {
                                                            size: "iconic",
                                                            icon: {
                                                              icon: "trash",
                                                              color:
                                                                "secondary",
                                                            },
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.openModalRemove(
                                                                group,
                                                                "category",
                                                                category
                                                              )
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    group.categories.length > 1
                                                      ? _c("c-button", {
                                                          directives: [
                                                            {
                                                              name: "b-popover",
                                                              rawName:
                                                                "v-b-popover.html",
                                                              value: {
                                                                id: "positions-button-popover",
                                                                container:
                                                                  "#app",
                                                                trigger:
                                                                  "hover",
                                                                content:
                                                                  "Переместить",
                                                                placement:
                                                                  "top",
                                                              },
                                                              expression:
                                                                "{\n                                id: 'positions-button-popover',\n                                container: '#app',\n                                trigger: 'hover',\n                                content: 'Переместить',\n                                placement: 'top',\n                              }",
                                                              modifiers: {
                                                                html: true,
                                                              },
                                                            },
                                                          ],
                                                          attrs: {
                                                            size: "iconic",
                                                            icon: "arrows-constructor",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-collapse",
                                              {
                                                staticClass:
                                                  "constructor__posts__collapse",
                                                class: {
                                                  constructor__posts__collapse__show:
                                                    category.posts.length === 0,
                                                },
                                                attrs: {
                                                  id: `group-category-collapse-${group.groupId}-${category.categoryId}`,
                                                },
                                              },
                                              [
                                                _c(
                                                  "draggable",
                                                  {
                                                    class: `group-list-${group.code}`,
                                                    attrs: {
                                                      list: category.posts,
                                                      group: "posts",
                                                      move: _vm.checkPostMove,
                                                      "force-fallback": true,
                                                      "ghost-class":
                                                        "sortable__ghost",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.movePostRequest(
                                                          $event,
                                                          group,
                                                          category
                                                        )
                                                      },
                                                    },
                                                  },
                                                  _vm._l(
                                                    category.posts,
                                                    function (post, iPost) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: `${index}-${i}-${iPost}`,
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "constructor__element constructor__element__category__children",
                                                              class: {
                                                                constructor__element__last__post:
                                                                  category.posts
                                                                    .length ===
                                                                    iPost + 1 &&
                                                                  _vm.localItems
                                                                    .length !==
                                                                    index + 1,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "constructor__element__name constructor__element__name__post",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        post.name
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "b-link",
                                                                {
                                                                  staticClass:
                                                                    "constructor__element-icons",
                                                                  attrs: {
                                                                    disabled:
                                                                      "",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "c-button",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "b-popover",
                                                                            rawName:
                                                                              "v-b-popover.html",
                                                                            value:
                                                                              {
                                                                                id: "positions-button-popover",
                                                                                container:
                                                                                  "#app",
                                                                                trigger:
                                                                                  "hover",
                                                                                content:
                                                                                  "Редактировать",
                                                                                placement:
                                                                                  "top",
                                                                              },
                                                                            expression:
                                                                              "{\n                                      id: 'positions-button-popover',\n                                      container: '#app',\n                                      trigger: 'hover',\n                                      content: 'Редактировать',\n                                      placement: 'top',\n                                    }",
                                                                            modifiers:
                                                                              {
                                                                                html: true,
                                                                              },
                                                                          },
                                                                        ],
                                                                      staticClass:
                                                                        "constructor__element-icons-edit",
                                                                      attrs: {
                                                                        size: "iconic",
                                                                        icon: "edit",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.goToUpdatePostTest(
                                                                              post.code
                                                                            )
                                                                          },
                                                                      },
                                                                    }
                                                                  ),
                                                                  post.code !==
                                                                    "driver" &&
                                                                  Number(
                                                                    post.countWorkers
                                                                  ) > 0
                                                                    ? _c(
                                                                        "c-button",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "b-popover",
                                                                                rawName:
                                                                                  "v-b-popover.html",
                                                                                value:
                                                                                  {
                                                                                    id: "positions-disable-delete-popover",
                                                                                    container:
                                                                                      "#app",
                                                                                    trigger:
                                                                                      "click blur",
                                                                                    content:
                                                                                      _vm.getPostTemplatePopover(
                                                                                        post.code
                                                                                      ),
                                                                                  },
                                                                                expression:
                                                                                  "{\n                                      id: 'positions-disable-delete-popover',\n                                      container: '#app',\n                                      trigger: 'click blur',\n                                      content: getPostTemplatePopover(post.code),\n                                    }",
                                                                                modifiers:
                                                                                  {
                                                                                    html: true,
                                                                                  },
                                                                              },
                                                                              {
                                                                                name: "b-tooltip",
                                                                                rawName:
                                                                                  "v-b-tooltip.html",
                                                                                value:
                                                                                  {
                                                                                    id: "positions-button-tooltip",
                                                                                    container:
                                                                                      "#app",
                                                                                    trigger:
                                                                                      "hover",
                                                                                    content:
                                                                                      "Удалить",
                                                                                    title:
                                                                                      "Удалить",
                                                                                    placement:
                                                                                      "top",
                                                                                  },
                                                                                expression:
                                                                                  "{\n                                      id: 'positions-button-tooltip',\n                                      container: '#app',\n                                      trigger: 'hover',\n                                      content: 'Удалить',\n                                      title: 'Удалить',\n                                      placement: 'top',\n                                    }",
                                                                                modifiers:
                                                                                  {
                                                                                    html: true,
                                                                                  },
                                                                              },
                                                                            ],
                                                                          staticClass:
                                                                            "constructor__element-icons-delete",
                                                                          class:
                                                                            {
                                                                              "constructor__element-icons-delete-disabled":
                                                                                category.posts !==
                                                                                  undefined &&
                                                                                category
                                                                                  .posts
                                                                                  .length >
                                                                                  1,
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              size: "iconic",
                                                                              icon: {
                                                                                icon: "trash",
                                                                                color:
                                                                                  "secondary",
                                                                              },
                                                                            },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                  post.code !==
                                                                    "driver" &&
                                                                  Number(
                                                                    post.countWorkers
                                                                  ) === 0
                                                                    ? _c(
                                                                        "c-button",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "b-popover",
                                                                                rawName:
                                                                                  "v-b-popover.html",
                                                                                value:
                                                                                  {
                                                                                    id: "positions-button-popover",
                                                                                    container:
                                                                                      "#app",
                                                                                    trigger:
                                                                                      "hover",
                                                                                    content:
                                                                                      "Удалить",
                                                                                    placement:
                                                                                      "top",
                                                                                  },
                                                                                expression:
                                                                                  "{\n                                      id: 'positions-button-popover',\n                                      container: '#app',\n                                      trigger: 'hover',\n                                      content: 'Удалить',\n                                      placement: 'top',\n                                    }",
                                                                                modifiers:
                                                                                  {
                                                                                    html: true,
                                                                                  },
                                                                              },
                                                                            ],
                                                                          staticClass:
                                                                            "constructor__element-icons-delete",
                                                                          attrs:
                                                                            {
                                                                              size: "iconic",
                                                                              icon: {
                                                                                icon: "trash",
                                                                                color:
                                                                                  "secondary",
                                                                              },
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.openModalRemove(
                                                                                  group,
                                                                                  "post",
                                                                                  post
                                                                                )
                                                                              },
                                                                          },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                  _c(
                                                                    "c-button",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "b-popover",
                                                                            rawName:
                                                                              "v-b-popover.html",
                                                                            value:
                                                                              {
                                                                                id: "positions-button-popover",
                                                                                container:
                                                                                  "#app",
                                                                                trigger:
                                                                                  "hover",
                                                                                content:
                                                                                  "Переместить",
                                                                                placement:
                                                                                  "top",
                                                                              },
                                                                            expression:
                                                                              "{\n                                      id: 'positions-button-popover',\n                                      container: '#app',\n                                      trigger: 'hover',\n                                      content: 'Переместить',\n                                      placement: 'top',\n                                    }",
                                                                            modifiers:
                                                                              {
                                                                                html: true,
                                                                              },
                                                                          },
                                                                        ],
                                                                      attrs: {
                                                                        size: "iconic",
                                                                        icon: "arrows-constructor",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm.localItems.length === 0
                        ? _c(
                            "div",
                            {
                              staticClass: "constructor__section-content-empty",
                            },
                            [_vm._v(" Совпадений не найдено ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }